import React, { VFC } from 'react';
import { TooltippedButtonWrapper, TooltippedButtonWrapperProps } from '@tanium/react-button-base';
import { IconButton, IconButtonProps } from './IconButton';

export interface TooltippedIconButtonProps
  extends IconButtonProps,
    Pick<
      TooltippedButtonWrapperProps,
      'tooltipContent' | 'tooltipModifiers' | 'tooltipPlacement'
    > {}

const TooltippedIconButtonInner = React.forwardRef<HTMLButtonElement, TooltippedIconButtonProps>(
  ({ tooltipContent, tooltipModifiers, tooltipPlacement, ...props }, forwardedRef) => (
    <TooltippedButtonWrapper
      tooltipContent={tooltipContent}
      tooltipModifiers={tooltipModifiers}
      tooltipPlacement={tooltipPlacement}
      disabled={props.disabled}
    >
      <IconButton {...props} ref={forwardedRef} />
    </TooltippedButtonWrapper>
  ),
);

TooltippedIconButtonInner.displayName = 'TooltippedIconButton';

// This type cast provides better typings and Intellisense for consumers
export const TooltippedIconButton = TooltippedIconButtonInner as VFC<
  TooltippedIconButtonProps & { ref?: React.Ref<HTMLButtonElement> }
>;
